import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';

export class EQueryBuildPart extends BaseBuildPart {
    constructor(private readonly eQueryHelperParams: HelperParams,
                parent: BaseBuildPart,
                siteId?: number) {
        super(eQueryHelperParams, parent,  siteId ? ['e-queries', siteId] : ['e-queries']);
    }

    public awaitingResponse() {
        return new BaseBuildPart(this.eQueryHelperParams, this, ['awaiting']);
    }

    public responseSubmitted() {
        return new BaseBuildPart(this.eQueryHelperParams, this, ['submitted']);
    }
}
